import Layout from '@/AppMain.vue';

const promotions= {
    path: '/users',
    name: 'Users',
    component: Layout,
    children:[
        {
            path: '/users',
            name: 'Users',
            component: () => import('@/views/users/browse'),
            meta: {title: 'Users', auth: true, name: 'Users', back:'/', middlewares:['admin']},
        },
        {
            path: '/users/:id',
            name: 'User',
            component: () => import('@/views/users/edit'),
            meta: {title: 'Users', auth: true, name:'Users', back:'/users', middlewares:['admin'], breadcrumbs: [{title: 'Dashboard', to: '/'}, {title:"Users", to:'/users'}]}
        },
    ]
};
export default promotions;
